/**
 * Available Routes in the App.
 */
export const ROUTES = {
	home: "/",
	Analytics: "/analytics",
	issues: "/issues",
	Taxonomies: "/taxonomies",
	CourseDetails: {
		path: "/taxonomies/course/:id",
		buildPath: (id: string) => `/taxonomies/course/${id}`,
	},
	Media: "/media",
	Banner: "/banner",
	CreateBanner: "/banner/create",
	EditBanner: "/banner/:id/edit",
	LandingPageBanner: "/landing-page-banner",
	CreateLandingPageBanner: "/landing-page-banner/create",
	EditLandingPageBanner: "/landing-page-banner/:id/edit",
	Assessments: "/assessments",
	MediaDetails: "/media/:id",
	EditMedia: "/media/:id/edit",
	Reels: "/reels",
	ReelDetails: "/reels/:id",
	EditReel: "/reels/:id/edit",
	CreateReel: "/reels/create",
	Tags: "/tags",
	CreateTag: "/tags/create",
	EditTag: "/tags/:id/edit",
	Programs: "/programs",
	CreateProgram: "/programs/create",
	EditProgram: "/program/:id/edit",
	ProgramDetails: "/programs/:id",
	ManualNotification: "/notification/manual",
	CreateNotification: "/notification/manual/create",
	EditNotification: "/notification/manual/:id/edit",
	AutomaticNotification: "/notification/automatic",
	Courses: "/courses",
	CreateCourse: "/courses/create",
	EditCourse: "/courses/:id/edit",
	PreviewCourse: "/courses/:id/preview",
	ViewCourse: "/courses/:id/view",
	SyncLogs: "/courses/sync-logs",
	SyncLogDetails: {
		path: "/courses/sync-logs/:id",
		buildPath: (id: string) => `/courses/sync-logs/${id}`,
	},
	Permisstions: "/permissions",
	CreateAdmin: "/permissions/create-admin",
	Roles: "/roles",
	CreateRole: "/roles/create",
	EditRole: {
		path: "/roles/:id/edit",
		buildPath: (id: string) => `/roles/${id}/edit`,
	},
	Messages: "/users/messages",
	UserFeedbackOverview: "/users/user-feedback/overview",
	FeedbacksListing: "/users/user-feedback/messages",
	FeedbackDetails: "/users/user-feedback/messages/:id",
	LiveSessions: "/live-sessions",
	CreateSession: "/live-sessions/create",
	MessageDetails: "/users/messages/:id",
	EditSession: "/live-sessions/:id/edit",
	Providers: "/providers",
	CreateProvider: "/providers/create",
	EditProvider: "/providers/:id/edit",
	PreviewProvider: "/providers/:id/preview",
	Categories: "/categories",
	PreviewCategory: "/categories/:id/preview",
	CreateCategory: "/categories/create",
	EditCategory: "/categories/:id/edit",
	Hubs: "/hubs",
	CreateHub: "/hubs/create",
	NavbarSections: "/navbar-sections",
	EditNavbarSection: "/navbar-sections/:id/edit",
	PreviewNavbarSection: "/navbar-sections/:id/preview",
	CreateNavbarSection: "/navbar-sections/create",
	Users: "/users",
	CreateUser: "/users/create",
	PreviewUser: "/users/:id/preview",
	EditUser: {
		path: "/users/:id/edit",
		buildPath: (id: string) => `/users/${id}/edit`,
	},
	ChangePassword: "/change-password",
	Tiers: "/tiers",
	CreateTier: "/tiers/create",
	EditTier: "/tiers/:id/edit",
	Vouchers: "/vouchers",
	CreateVoucher: "/vouchers/create",
	EditVoucher: "/vouchers/:id/edit",
	Opportunities: "/opportunities",
	CreateOpportunity: "/opportunities/create",
	EditOpportunity: "/opportunities/:id/edit",
	Competitions: "/competitions",
	CreateCompetition: "/competitions/create",
	EditCompetition: "/competitions/:id/edit",
	ViewCompetition: {
		path: "/competitions/:id",
		buildPath: (id: string) => `/competitions/${id}`,
	},
	Partners: "/partners",
	PartnerDetails: {
		path: "/partners/:id",
		buildPath: (id: string) => `/partners/${id}`,
	},
	Login: "/login",
};
